export default "__VITE_ASSET__CYYwnkfc__"